import { render, staticRenderFns } from "./HeaderItemText.vue?vue&type=template&id=1d99c661&scoped=true&"
import script from "./HeaderItemText.vue?vue&type=script&lang=ts&"
export * from "./HeaderItemText.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderItemText.vue?vue&type=style&index=0&id=1d99c661&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99c661",
  null
  
)

export default component.exports